/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const md5 = require('blueimp-md5');

const deps = [];
const service = function () {
  class AvatarUrl {
    getAvatar(email, size = 80) {
      if (email) {
        return `https://secure.gravatar.com/avatar/${md5(email)}?d=mm&s=${size}`;
      }

      return '';
    }
  }

  return new AvatarUrl();
};

service.$inject = deps;
module.exports = service;
